import type {
  OrderCancellationPolicyActionType,
  OrderCancellationPolicyEscalationAdminDto
} from '@/backend/market'

export class OrderCancellationPolicyEntity {
  id?: number
  name?: string | null
  description?: string | null
  isEnabled?: boolean
  countThreshold?: number
  windowHours?: number
  actionType?: OrderCancellationPolicyActionType
  closeDurationHours?: number | null
  cancellationRatioPercentageThreshold?: number | null
  priority?: number
  cancelOrderReasonIds?: number[] | null
  escalation?: OrderCancellationPolicyEscalationAdminDto
}
